if (!customElements.get('cashback-earnbox')) {
  class CashbackEarnbox extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.data = this.getData();

      if (this.section) {
        this.section.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }
    }

    getData() {
      const dataEl = this.querySelector('.cashback-earnbox__data');
      if (!dataEl) return {};

      try {
        return JSON.parse(dataEl.textContent);
      } catch (e) {
        return {};
      }
    }

    handleVariantChange(evt) {
      const variant = evt.detail && evt.detail.variant;
      if (!variant) return;

      const values = this.data[variant.id];
      if (!values) return;

      this.setAttribute('data-variant-id', variant.id);

      const bopisEl = this.querySelector('[data-cashback-field="bopis"]');
      const deliveryEl = this.querySelector('[data-cashback-field="delivery"]');

      if (bopisEl && values.bopis) bopisEl.innerHTML = values.bopis;
      if (deliveryEl && values.delivery) deliveryEl.innerHTML = values.delivery;
    }
  }

  customElements.define('cashback-earnbox', CashbackEarnbox);
}
